<template>
  <div class="view-gabarit">
    <h2 class="head-box-title">{{ $t('modal.studyParametersSummary') }}</h2>

    <Parameters :study="study" />

    <div v-if="userInfo.role_id !== 3" class="expiration-container">
      <div class="expiration-text">{{ $t('expireAt') }}</div>

      <div class="expiration-date">{{ expirationDate }}</div>

      <div v-if="userInfo.role_id === 0 && !study.has_been_renewed" class="study-button" @click="renewExpirationDate">
        {{ $t('renewExpirationDate') }}
      </div>

      <VueDatePicker v-if="userInfo.role_id === 1" v-model="selectedDate" :time-config="{ enableTimePicker: false }">
        <template #trigger>
          <div class="study-button">
            <span>{{ $t('updateExpirationDate') }}</span>
          </div>
        </template>
      </VueDatePicker>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Parameters from '@/components/Study/Parameters';
import { formatDate } from '@/libraries/formatter';

export default {
  components: {
    Parameters,
  },

  props: ['params'],

  data() {
    return {
      formatDate,
      study: null,
      selectedDate: new Date().toISOString(),
    };
  },

  computed: {
    ...mapGetters(['userInfo']),

    expirationDate() {
      if (this.study) {
        return this.$d(new Date(this.study.expiration_date * 1000), 'date');
      }
      return '';
    },
  },

  watch: {
    selectedDate(value) {
      if (this.study) {
        const dateValue = new Date(value);
        this.updateExpirationDate(dateValue.getTime() / 1000);
      }
    },
  },

  mounted() {
    const id = this.params.id;
    this.$store.dispatch('getStudy', { id }).then(response => {
      this.study = response;
      this.selectedDate = new Date(this.study.expiration_date * 1000).toISOString();
    });
  },

  methods: {
    renewExpirationDate() {
      const id = this.params.id;
      this.$store.dispatch('renewExpirationDate', { id }).then(() => {
        this.study.expiration_date = this.study.expiration_date + 15724800;
        this.study.has_been_renewed = true;
      });
    },

    updateExpirationDate(date) {
      const id = this.params.id;
      this.$store.dispatch('updateExpirationDate', { id, expirationDate: date }).then(() => {
        this.study.expiration_date = date;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.modal-body {
  min-height: 480px;
}

.view-gabarit {
  margin-bottom: -18px;
  width: 1152px;
  max-width: 100%;
  padding-bottom: 32px;

  .view-row {
    margin-left: -30px;
    margin-right: -30px;
  }
}

.expiration-container {
  width: 256px;
  margin: 16px auto 0;
  padding: 8px 24px 0;
  text-align: center;

  .expiration-text {
    margin: 0 auto;
    font-size: 14px;
  }

  .expiration-date {
    margin: 0 auto;
    font-weight: 600;
    text-transform: capitalize;
  }

  .study-button {
    position: relative;
    margin: 12px auto 0;
    width: 128px;
    height: 32px;
    line-height: 32px;
    box-sizing: content-box;

    .vdatetime {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 38px;
    }
  }
}
</style>
